/**
 * Industrycodes taken from Adyen's published list:
 * https://docs.adyen.com/platforms/verification-requirements/reference-additional-products/industry-codes
 * Will need to be extended when we get new client types
 */
export interface IndustryCodeOption {
    value: string;
    labelKey: string;
    mcc: string;
}

export const FUNPAY_INDUSTRY_CODES: IndustryCodeOption[] = [
    { value: '71311', labelKey: 'FUNPAY_INDUSTRY_71311', mcc: '7996' },
    //Activity venue label, almost every venue goes in this.
    { value: '7139C', labelKey: 'FUNPAY_INDUSTRY_7139C', mcc: '7999' },
    { value: '71395', labelKey: 'FUNPAY_INDUSTRY_71395', mcc: '7933' },
    { value: '71394', labelKey: 'FUNPAY_INDUSTRY_71394', mcc: '7997' },
    { value: '71312', labelKey: 'FUNPAY_INDUSTRY_71312', mcc: '7994' },
    { value: '7139D', labelKey: 'FUNPAY_INDUSTRY_7139D', mcc: '7932' },
    { value: '7139A', labelKey: 'FUNPAY_INDUSTRY_7139A', mcc: '7992' },
    { value: '7139B', labelKey: 'FUNPAY_INDUSTRY_7139B', mcc: '7997' },
    { value: '71392', labelKey: 'FUNPAY_INDUSTRY_71392', mcc: '7999' },
    { value: '7139E', labelKey: 'FUNPAY_INDUSTRY_7139E', mcc: '7998' },
    { value: '712', labelKey: 'FUNPAY_INDUSTRY_712', mcc: '7991' },
    { value: '7113', labelKey: 'FUNPAY_INDUSTRY_7113', mcc: '7941' },
    { value: '61162', labelKey: 'FUNPAY_INDUSTRY_61162', mcc: '8299' },
    { value: '7212', labelKey: 'FUNPAY_INDUSTRY_7212', mcc: '7032' },
    { value: '722511', labelKey: 'FUNPAY_INDUSTRY_722511', mcc: '5812' },
    { value: '722513', labelKey: 'FUNPAY_INDUSTRY_722513', mcc: '5814' }
];

export const DEFAULT_INDUSTRY_CODE = '7139C';
